import * as z from "zod/v4";

export const updateGoogleFeedSettings = {
  name: "updateGoogleFeedSettings" as const,
  input: z.object({ teamId: z.string(), enabled: z.boolean() }),

  output: z.object({ success: z.boolean(), enabled: z.boolean() }),
};
